<template>
<el-container>
<el-main>
     <el-dialog
    :title="$t('roomDetail.batchRent')"
    :visible.sync="batchDialogVisible"
    width="480px"
    style="margin-top:-30px"
    >
      <el-form :inline="true" :model="rentForm" ref="rentForm" class="demo-ruleForm">
          <el-form-item :label="$t('systemRecord.endTime')" label-width="120">
            <el-date-picker v-model="rentForm.endTime" type="datetime" :placeholder="$t('systemRecord.chooseDate')">
            </el-date-picker>
          </el-form-item>
          <el-footer>
            <el-button type="primary" @click="rentConfirm">{{$t('roomDetail.confirm')}}</el-button>
            <el-button @click="batchDialogVisible = false">{{$t('roomDetail.cancle')}}</el-button>
          </el-footer>  
      </el-form>  
    </el-dialog>
     <el-dialog
    :title="$t('roomDetail.addLockAuth')"
    :visible.sync="addAuthDialogVisible"
    width="480px"
    style="margin-top:-30px"
    >
      <el-form :inline="true" :model="addAutoForm" ref="selectForm" class="demo-ruleForm">
        <el-form-item :label="$t('roomDetail.tenantName')" label-width="120">
         <el-select v-model="addAutoForm.userId" filterable :placeholder="$t('roomDetail.chooseCheckInTenant')" @change="tenantSelectChange" style="width:220px">
          <el-option
          v-for="item in addAutoForm.tenantData"
          :key="item.tenantId"
          :label="item.tenantName"
          :value="item.tenantId">
          </el-option>
        </el-select>
       </el-form-item>
       <el-form-item :label="$t('roomDetail.authType')" label-width="120">
            <el-radio v-model="addAutoForm.validType" label="0">{{$t('roomDetail.password')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="1">{{$t('roomDetail.doorCard')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="2">{{$t('roomDetail.idCard')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="3">{{$t('roomDetail.fingerprint')}}</el-radio>
       </el-form-item>  
       </br> 
       <el-form-item :label="$t('roomDetail.authContent')" label-width="120" v-show="addAutoForm.validType==0">
           <el-input v-model="addAutoForm.validData" :placeholder="$t('roomDetail.msgCreateSjPassword')" style="width:220px"></el-input>
       </el-form-item>   
       <el-form-item :label="$t('roomDetail.beginTime')" label-width="120">
        
           <el-date-picker
           v-model="addAutoForm.beginTime"
           type="datetime"
           :disabled="addAutoForm.beginFlag"
           :placeholder="$t('roomDetail.chooseBeginTime')">
           </el-date-picker>
         
       </el-form-item>  
       <el-form-item :label="$t('roomDetail.endTime')" label-width="120">
         <div class="block">
           <el-date-picker
           v-model="addAutoForm.endTime"
           type="datetime"
           :disabled="addAutoForm.endFlag"
           :placeholder="$t('roomDetail.chooseEndTime')">
           </el-date-picker>
         </div>
       </el-form-item>
       <el-footer>
         <el-button type="primary" @click="confirmAddAuth">{{$t('roomDetail.confirm')}}</el-button>
         <el-button @click="addAuthDialogVisible = false">{{$t('roomDetail.cancle')}}</el-button>
       </el-footer>  
     </el-form>      
    </el-dialog>
    <el-dialog
    :title="$t('roomDetail.tempPassword')"
    :visible.sync="pswDialogVisible"
    width="30%"
    >
    <span>{{$t('roomDetail.password')}}：{{this.offLinePassword.password}}</span></br>
    <span>{{$t('roomDetail.createTime')}}：{{this.offLinePassword.buildTime}}</span></br></br>
    <el-tag type="danger">{{$t('roomDetail.msg')}}</el-tag>
    <span slot="footer" class="dialog-footer">
      <el-button @click="pswDialogVisible = false">{{$t('roomDetail.cancle')}}</el-button>
      <el-button type="primary" @click="pswDialogVisible = false">{{$t('roomDetail.confirm')}}</el-button>
    </span>
   </el-dialog>
  <el-card class="box-card">
     <div slot="header" class="clearfix">
        <el-link icon="el-icon-back" type="success" @click="back">{{$t('roomDetail.back')}}</el-link>
          <!-- <el-button type="primary" size="small" style="float:right" @click="backHome">返回</el-button> -->
          <el-button type="primary" size="small" style="float:right" @click="getOffLinePassword">{{$t('roomDetail.getOfflinePassword')}}</el-button>
     </div>
     <el-form :inline="true" ref="selectForm" class="demo-ruleForm">
         <el-form-item :label="$t('roomDetail.deviceId')" style="width:230px">
            {{this.deviceData.deviceId}}
         </el-form-item>    
         <el-form-item :label="$t('roomDetail.deviceName')" style="width:230px">
            {{this.deviceData.deviceName}}
         </el-form-item>
         <el-form-item :label="$t('roomDetail.deviceType')" style="width:230px">
            {{this.deviceData.deviceType==0?$t('roomDetail.gateway'):this.deviceData.deviceType==1?$t('roomDetail.gatewayLock'):this.deviceData.deviceType==2?$t('roomDetail.offlineLock'):this.deviceData.deviceType==3?$t('roomDetail.nbNetLock'):this.deviceData.deviceType==4?$t('roomDetail.bleLock'):this.deviceData.deviceType==5?$t('roomDetail.4gLock'):this.deviceData.deviceType==6?$t('roomDetail.wifiLock'):this.deviceData.deviceType}}
         </el-form-item>
         <el-form-item :label="$t('roomDetail.power')" style="width:230px">
            {{this.deviceData.battery}}%
         </el-form-item>
        <el-form-item :label="$t('roomDetail.onlineStatus')" style="width:230px">
            {{this.deviceData.isOnline==0?$t('roomDetail.offline'):this.deviceData.isOnline==1?$t('roomDetail.online'):''}}
         </el-form-item>
          <el-form-item :label="$t('roomDetail.lockModel')" style="width:230px">
            {{this.deviceData.modelNo}}
         </el-form-item>
         <el-form-item :label="$t('roomDetail.hardwareVersion')" style="width:230px">
            {{this.deviceData.hardwareVersion}}
         </el-form-item>
         <el-form-item :label="$t('roomDetail.SoftwareVersion')" style="width:230px">
            {{this.deviceData.enVersion}}
         </el-form-item>
     </el-form>
    </el-card>
    <el-card class="box-card">
     <el-tabs v-model="activeName" type="card" @tab-click="">
      <el-tab-pane :label="$t('roomDetail.userList')" name="userList">
         <!-- <el-input style="width:280px" v-model="selectForm.tenantName" placeholder="请输入租客名称，多个租客以逗号分隔"></el-input>
         <el-button type="primary"  icon="el-icon-search" @click="queryTenant">查询</el-button> -->
         <el-button type="primary"  @click="batchCheckOut">{{$t('roomDetail.batchCheckOut')}}</el-button>
         <el-button type="primary"  @click="batchRent">{{$t('roomDetail.batchRent')}}</el-button>
         <el-button type="primary"  @click="shuaxin">{{$t('roomDetail.refresh')}}</el-button>
         <el-table
         :data="userPageData.userData"
         :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
         empty-text="No Data"
         border
         style="margin-top: 5px"
         @selection-change="userDataSelectionChange"
         >
        
        <el-table-column
         type="selection"
         width="55">
        </el-table-column>

        <el-table-column
         prop="tenantName"
         :label="$t('roomDetail.tenantName')">
        </el-table-column>

        <el-table-column
         prop="isManager"
         :label="$t('roomDetail.userType')">
         <template slot-scope="scope">
           {{scope.row.isManager==0?$t('roomDetail.tenant'):scope.row.isManager==1?$t('roomDetail.admin'):""}}
         </template>
        </el-table-column>

        <el-table-column
         prop="roomName"
         :label="$t('roomDetail.roomName')">
        </el-table-column>

       <!-- <el-table-column
         prop="status"
         label="状态">
       </el-table-column> -->

       <!-- <el-table-column
         prop="isLimit"
         label="是否有限期">
          <template slot-scope="scope">
             {{scope.row.isLimit==0?"无限期":scope.row.isLimit==1?"有限期":""}}
          </template> 
       </el-table-column> -->

        <el-table-column
         prop="beginTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.beginTime')">
       </el-table-column>

        <el-table-column
         prop="endTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.endTime')">
       </el-table-column>
     
         </el-table>
      <el-footer>
      <div>
        <Pagings
        :total="userPageData.total"
        :offset="userPageData.offset"
        :pageSize="userPageData.pageNumber"
        @handleSizeChangeSub="userHandleSizeChange"
        @handleCurrentChangeSub="userHandleCurrentChange">
        </Pagings>
      </div>
      </el-footer> 
      </el-tab-pane>  
      <el-tab-pane :label="$t('roomDetail.authList')" name="authList">
        <el-button type="primary"  @click="openAddAuthDialog">{{$t('roomDetail.addAuth')}}</el-button>
        <el-button type="primary"  @click="batchChongfa">{{$t('roomDetail.batchRetry')}}</el-button>
        <el-button type="primary"  icon="el-icon-search" @click="shuaxin">{{$t('roomDetail.refresh')}}</el-button>
         <el-table
         :data="authPageData.authData"
         :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
         empty-text="No Data"
         border
         style="margin-top: 5px"
         @selection-change="authDataSelectionChange"
         :row-class-name="tableRowClassName"
         >

        <el-table-column
         type="selection"
         width="55">
        </el-table-column>

        <el-table-column 
        type="index" 
        :label="$t('systemRecord.number')" 
        width="100" 
        align="center">
        </el-table-column>
        
        <el-table-column
         prop="validType"
          width=130
         :label="$t('roomDetail.authType')">
         <template slot-scope="scope">
          {{scope.row.validType==0?$t('roomDetail.password'):scope.row.validType==1?$t('roomDetail.doorCard'):scope.row.validType==2?$t('roomDetail.idCard'):scope.row.validType==3?$t('roomDetail.fingerprint'):scope.row.validType==4?$t('roomDetail.bluetooth'):""}}
         </template>
        </el-table-column>

         <el-table-column
         prop="authorizationUserId"
         width="100"
         :label="$t('roomDetail.authId')">
        </el-table-column>

         <el-table-column
         prop="authorizationName"
         width="100"
         :label="$t('roomDetail.authName')">
        </el-table-column>

       <el-table-column
         prop="validData"
         :label="$t('roomDetail.authContent')">
         <template slot-scope="scope">
           <!-- {{scope.row.validUser==3?JSON.parse(scope.row.validData).data:scope.row.validData}} -->
          <span  v-if="scope.row.validUser==3">
            {{JSON.parse(scope.row.validData).data}}
          </span> 

          <span v-else> 
            <span v-show="scope.row.validType==0">
              
             <span v-if="scope.row.index === tabClickIndex">
              {{scope.row.validData}}
              <i @click="hidePassWord(scope.row)" style="cursor: pointer;" class="el-icon-view"></i>
              </span>
             <span v-else>
              ******
              <i @click="showPassWord(scope.row)" style="color:blue;cursor: pointer;" class="el-icon-view"></i>
             </span>
            </span>

            <span v-show="scope.row.validType!=0">
              {{scope.row.validData}}
            </span>
          </span> 

         </template>  
       </el-table-column>

        <el-table-column
         prop="status"
         width=100
         :label="$t('roomDetail.authStatus')">
          <template slot-scope="scope">
             {{scope.row.status==0?$t('roomDetail.stop'):scope.row.status==1?$t('roomDetail.start'):scope.row.status==2?$t('roomDetail.invalid'):scope.row.status==3?$t('roomDetail.delete'):scope.row.status==4?$t('roomDetail.toDelete'):scope.row.status==5?$t('fingerprintList.freeze'):""}}
          </template>  
       </el-table-column>

        <el-table-column
         prop="beginTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.beginTime')">
       </el-table-column>

        <el-table-column
         prop="endTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.endTime')">
       </el-table-column>

      <el-table-column
       prop
       :label="$t('roomDetail.operate')"
       width="150"
       align="center"
      >
       <template slot-scope="scope">
         
          <el-button
          type="warning"
          size="mini"
          v-show="scope.row.status==1"
          @click="freezeAuth(scope.$index, scope.row)"
         >{{$t('fingerprintList.freeze')}}</el-button>

          <el-button
          type="primary"
          size="mini"
          v-show="scope.row.status==5"
          @click="removeAuth(scope.$index, scope.row)"
         >{{$t('deviceList.thaw')}}</el-button>

        <el-button
          type="danger"
          size="mini"
          @click="deleteAuth(scope.$index, scope.row)"
         >{{$t('roomDetail.delete')}}</el-button>
       </template>
      </el-table-column>
     
      </el-table>
      <el-footer>
       <div>
        <Pagings
        :total="authPageData.total"
        :offset="authPageData.offset"
        :pageSize="authPageData.pageNumber"
        @handleSizeChangeSub="authHandleSizeChange"
        @handleCurrentChangeSub="authHandleCurrentChange">
        </Pagings>
       </div>
      </el-footer> 
      </el-tab-pane> 
      <el-tab-pane :label="$t('roomDetail.openDoorRecords')" name="openRecord">
        <el-table
         :data="openRecordPageData.openRecordData"
         :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
         empty-text="No Data"
         border
         style="margin-top: 5px"
         >

        <el-table-column 
        type="index" 
        :label="$t('systemRecord.number')" 
        width="100" 
        align="center">
        </el-table-column>

        <el-table-column
         prop="authorizationName"
         :label="$t('roomDetail.userName')">
        </el-table-column>

        <el-table-column
         prop="authorizationUserId"
         :label="$t('roomDetail.userId')">
        </el-table-column>

       <el-table-column
         prop="validType"
         :label="$t('roomDetail.openLockModel')">
           <template slot-scope="scope">
             {{scope.row.validType==0?$t('roomDetail.unknownUser'):scope.row.validType==1?$t('roomDetail.remoteUnlock'):scope.row.validType==2?$t('roomDetail.passwordUser'):scope.row.validType==3?$t('roomDetail.cardUser'):scope.row.validType==4?$t('roomDetail.fingerprintUser'):scope.row.validType==5?$t('roomDetail.bluetooth'):scope.row.validType==7?$t('tenant.IDCard'):""}}
           </template> 
       </el-table-column>

        <el-table-column
         prop="openTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.openLockTime')">
       </el-table-column>

        </el-table>
      <el-footer>
        <div>
         <Pagings
          :total="openRecordPageData.total"
          :offset="openRecordPageData.offset"
          :pageSize="openRecordPageData.pageNumber"
          @handleSizeChangeSub="openRecordHandleSizeChange"
          @handleCurrentChangeSub="openRecordHandleCurrentChange">
         </Pagings>
        </div>
      </el-footer> 
      </el-tab-pane>  
      <el-tab-pane :label="$t('roomDetail.alarmRecord')" name="alarmRecord">
        <el-table
         :data="alarmRecordPageData.alarmRecordData"
         :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
         empty-text="No Data"
         border
         style="margin-top: 5px"
         >
        
        <el-table-column 
        type="index" 
        :label="$t('systemRecord.number')" 
        width="100" 
        align="center">
        </el-table-column>

        <el-table-column
         prop="deviceId"
         :label="$t('roomDetail.lockId')">
        </el-table-column>

        <!-- <el-table-column
         prop="alarmId"
         label="报警记录ID">
        </el-table-column> -->

        <el-table-column
         prop="alarmMessage"
         :label="$t('roomDetail.alarmRemark')">
        </el-table-column>

       <el-table-column
         prop="alarmType"
         :label="$t('roomDetail.alarmType')">
       </el-table-column>

       <el-table-column
         prop="createTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.alarmTime')">
       </el-table-column>

        </el-table> 

      <el-footer>
        <div>
         <Pagings
          :total="alarmRecordPageData.total"
          :offset="alarmRecordPageData.offset"
          :pageSize="alarmRecordPageData.pageNumber"
          @handleSizeChangeSub="alarmRecordHandleSizeChange"
          @handleCurrentChangeSub="alarmRecordHandleCurrentChange">
         </Pagings>
        </div>
      </el-footer>   
      </el-tab-pane>   
     </el-tabs>  
    </el-card> 
</el-main>
</el-container>    
</template>

<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "roomDetail",
  data() {
     return {
         batchDialogVisible:false,
         rentForm:{
            endTime:""
         },
         selectForm:{
           tenantName:""
         },
         activeName:"userList",
         apartmentId:this.$route.query.apartmentId,
         roomId:this.$route.query.roomId,
         deviceId:this.$route.query.deviceId,
         deviceData:"",
         userPageData:{
           offset: 1,
           pageNumber: 10,
           total: 0, //总条数
           userData: []
         },
         authPageData:{
           offset: 1,
           pageNumber: 10,
           total: 0, //总条数
           authData: []
         },
         openRecordPageData:{
           offset: 1,
           pageNumber: 10,
           total: 0, //总条数
           openRecordData: []
         },
         alarmRecordPageData:{
           offset: 1,
           pageNumber: 10,
           total: 0, //总条数
           alarmRecordData: []
         },
         pswDialogVisible:false,
         offLinePassword:"",
         multipleSelection: [],
         addAuthDialogVisible:false,
         multipleSelectionAuth:[],
         addAutoForm:{
          beginTime:"",
          endTime:"",
          isLimit:0,
          isLocked:0,
          isOpen:0,
          validType:'0',
          userId:"",
          tenantName:"",
          tenantData:[],
          validData:""
       },
       tabClickIndex:''
     }
  },
  components: {
    Pagings
  },
  mounted() {
      this.getUserPage();
      this.getTenantPage();
      if(this.deviceId!=""&&this.deviceId!=null){
        this.getDeviceDetail();
        this.getAuthPage();
        this.getOpenRecordPage();
        this.getAlarmRecordPage();
      }
  },  

  methods: {
    tableRowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
    },
    //显示密码
    showPassWord(row){
      this.tabClickIndex=row.index;
    },
    //隐藏密码
    hidePassWord(){
      this.tabClickIndex='';
    },
    //批量重发
    batchChongfa(){
       if(this.multipleSelectionAuth.length==0){
          this.$message({
            message:this.$t("roomDetail.qxzcfdsqjl"),
            type: "warning"
          });
         return false;
       }
       var authInfoIds=[];
       for(var str in this.multipleSelectionAuth){
             authInfoIds.push(this.multipleSelectionAuth[str].authInfoId);
       }
       this.$confirm(this.$t("roomDetail.qdycfsqm"),this.$t("tenant.hint"), {
              confirmButtonText: this.$t("tenant.confirm"),
              cancelButtonText: this.$t("tenant.cancel"),
                type: 'warning'
              }).then(() => {
                  var formData = new FormData();
                  formData.append("authInfoIds",JSON.stringify(authInfoIds));
                  this.$server
                   .exam("/customer/lock/batchRetryLockAuthorization", formData)
                   .then(data => {
                     if (data.code == 200) {
                        this.$message({
                         message:this.$t('roomDetail.authSuccess'),
                         type: "success"
                        });
                       this.getAuthPage();
                      } else {
                        this.$message({
                          message: data.message,
                          type: "warning"
                        });
                      }
                    });  
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t("tenant.cancelDelete")
                }); 
              });     
    },
    //确认批量续租
    rentConfirm(){
       if(this.rentForm.endTime==""||this.rentForm.endTime==null){
          this.$message({
            message:this.$t("roomDetail.qxzxzjsrq"),
            type: "warning"
         });
         return false;
       }
       var tenantIds=[];
       for(var str in this.multipleSelection){
             tenantIds.push(this.multipleSelection[str].tenantId);
       }
       this.$confirm(this.$t("roomDetail.qdyxqzksqm"),this.$t("tenant.hint"), {
              confirmButtonText: this.$t("tenant.confirm"),
              cancelButtonText: this.$t("tenant.cancel"),
                type: 'warning'
              }).then(() => {
                  var formData = new FormData();
                  formData.append("roomId",this.roomId);
                  formData.append("endTime",this.$util.formartDateTime(this.rentForm.endTime));
                  formData.append("tenantIds",JSON.stringify(tenantIds));
                  this.$server
                   .exam("/customer/tenant/tenantRenewal", formData)
                   .then(data => {
                     if (data.code == 200) {
                        this.$message({
                         message:this.$t('roomDetail.authSuccess'),
                         type: "success"
                        });
                       this.batchDialogVisible=false;
                       this.getUserPage();
                      } else {
                        this.$message({
                          message: data.message,
                          type: "warning"
                        });
                      }
                    });  
              }).catch(() => {
                this.$message({
                  type: 'info',
                 message: this.$t("tenant.cancelDelete")
                }); 
              });     
    },
    //打开批量续租
    batchRent(){
        if(this.multipleSelection.length==0||this.multipleSelection==''){
          this.$message({
            message:this.$t("apartmentRoomList.chooseTenant"),
            type: "warning"
          });
          return false;
       }
       this.batchDialogVisible=true;
    },
    //解除
    removeAuth(index,row){
       this.$confirm(this.$t("deviceList.confirmUnbindGateway"),this.$t("tenant.hint"), {
              confirmButtonText: this.$t("tenant.confirm"),
              cancelButtonText: this.$t("tenant.cancel"),
                type: 'warning'
              }).then(() => {
                  var authInfoId=row.authInfoId;
                  var formData = new FormData();
                  formData.append("authInfoId",authInfoId);
                  formData.append("status",2);//冻结
                  this.$server
                   .exam("/customer/lock/editLockAuthAuthorization", formData)
                   .then(data => {
                     if (data.code == 200) {
                        this.$message({
                         message:this.$t('roomDetail.authSuccess'),
                         type: "success"
                        });
                       this.getAuthPage();
                      } else {
                        this.$message({
                          message: data.message,
                          type: "warning"
                        });
                      }
                    });  
              }).catch(() => {
                this.$message({
                  type: 'info',
                 message: this.$t("tenant.cancelDelete")
                }); 
              });     
    },
    //冻结
    freezeAuth(index,row){
       this.$confirm(this.$t("deviceList.confirmUnbindLock"),this.$t("tenant.hint"), {
              confirmButtonText: this.$t("tenant.confirm"),
              cancelButtonText: this.$t("tenant.cancel"),
                type: 'warning'
              }).then(() => {
                  var authInfoId=row.authInfoId;
                  var formData = new FormData();
                  formData.append("authInfoId",authInfoId);
                  formData.append("status",1);//冻结
                  this.$server
                   .exam("/customer/lock/editLockAuthAuthorization", formData)
                   .then(data => {
                     if (data.code == 200) {
                        this.$message({
                         message:this.$t('roomDetail.authSuccess'),
                         type: "success"
                        });
                       this.getAuthPage();
                      } else {
                        this.$message({
                          message: data.message,
                          type: "warning"
                        });
                      }
                    });  
              }).catch(() => {
                this.$message({
                  type: 'info',
                 message: this.$t("tenant.cancelDelete")
                }); 
              });     
    },
    //租客查询
    queryTenant(){
      this.getUserPage();
    },
    //返回
    back(){
      this.$router.push({path:"/roomList",query: {apartmentId:this.apartmentId}});
    },
    //租客选择
    tenantSelectChange(val){
     this.addAutoForm.tenantName=val.tenantName;
     var obj = {};
     obj = this.addAutoForm.tenantData.find((item)=>{//遍历list的数据
       return item.tenantId === val;//筛选出匹配数据
     });
     this.addAutoForm.tenantName=obj.tenantName;
     this.addAutoForm.beginTime=this.$util.formartDateTime(obj.beginTime);
     this.addAutoForm.endTime=this.$util.formartDateTime(obj.endTime);
     this.addAutoForm.beginFlag=true;
      this.addAutoForm.endFlag=true;
    },
    //确定添加授权
    confirmAddAuth(){
      var formData = new FormData();
      if(this.addAutoForm.beginTime!=""&&this.addAutoForm.endTime!=""){
        formData.append("beginTime",this.$util.formartDateTime(this.addAutoForm.beginTime));
        formData.append("endTime",this.$util.formartDateTime(this.addAutoForm.endTime));
      }else{
         this.$message({
            message:this.$t('roomDetail.chooseCheckInTime'),
            type: "warning"
          });
          return false;
      }
      if(this.addAutoForm.tenantName==""||this.addAutoForm.tenantName==null){
        this.$message({
            message:this.$t('tenant.tenantName-input'),
            type: "warning"
          });
          return false;
      }
       formData.append("authorizationName",this.addAutoForm.tenantName+this.$t('roomDetail.msg1'));
       formData.append("isLimit",1);
       formData.append("validUser ",2);//临时用户
       formData.append("validType",this.addAutoForm.validType);
       if(this.addAutoForm.validType=="0"){
        formData.append("validData",this.addAutoForm.validData);
       }
       formData.append("isLocked",0);
       formData.append("isOpen",0);
       formData.append("isSendSms",0);
       formData.append("lockId",this.deviceData.deviceId);
       formData.append("userId",this.addAutoForm.userId);//租客ID
       formData.append("validDataIsExist",1);
      this.$server
      .exam("/customer/lock/addLockAuthorization", formData)
      .then(data => {
        if (data.code == 200) {
          this.addAuthDialogVisible=false;
          this.$message({
            message:this.$t('roomDetail.authSuccess'),
            type: "success"
          });
          this.getAuthPage();
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },
    //打开添加授权页面
    openAddAuthDialog(){
      this.addAuthDialogVisible=true;
    },
    //删除授权
    deleteAuth(index,row){
       var showTxt="";
       if(row.status==4){
         showTxt=this.$t('deviceDetail.toDeletShowTxt');
       }else{
         showTxt=this.$t('deviceDetail.deleteAuth-confirm1')+row.authorizationName+this.$t('deviceDetail.deleteAuth-confirm2'),this.$t('deviceDetail.hint');
       }
       this.$confirm(showTxt, {
          confirmButtonText: this.$t('deviceDetail.confirm'),
          cancelButtonText: this.$t('deviceDetail.cancel'),
          type: 'warning'
        }).then(() => {
           var formData = new FormData();
           formData.append("authInfoId", row.authInfoId);
           formData.append("isDelete", 0);
           this.$server
          .exam("/customer/apartment/deleteLockAuthorization", formData)
          .then(data => {
            if (data.code == 200) {
               this.getAuthPage();
               this.$message({
                  message:this.$t('roomDetail.deleteAuthSuccess'),
                  type: "success"
                });
            } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
           }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('tenant.cancleDelete')
          });          
        });
    },
    //刷新用户列表
    shuaxin(){
      this.getUserPage();
      this.getAuthPage();
      this.getOpenRecordPage()
      this.getAlarmRecordPage();
      this.$message({
        message:this.$t('roomDetail.refreshSuccess'),
        type: "success"
      });
    },
    //批量退租
    batchCheckOut(){
      if(this.multipleSelection.length==0||this.multipleSelection==""){
          this.$message({
            message:this.$t('roomDetail.chooseCheckOutTenant'),
            type: "success"
          });
          return false;
      }
    this.$confirm(this.$t('roomDetail.confirmCheckOut'), this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
    }).then(() => {
      var formData = new FormData();
      formData.append("roomId", this.roomId);
      formData.append("userInfoList", JSON.stringify(this.jxUserData()));
      this.$server
      .exam("/customer/room/roomCheckOut", formData)
      .then(data => {
        if (data.code == 200) {
           this.$message({
            message:this.$t('roomDetail.checkOutSuccess'),
            type: "success"
          });
          this.getUserPage();
          this.getTenantPage();
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    }).catch(() => {
        this.$message({
          type: 'info',
          message:this.$t("tenant.cancelCheckOut")
        });          
    });  
    },
    //选择授权信息
    authDataSelectionChange(val){
      this.multipleSelectionAuth=val;
    },
    //入住租客选择
    userDataSelectionChange(val){
       this.multipleSelection=val;
    },
    //解析出选择的租客列表
    jxUserData(){
        var rtnData=[];
        var tenantData=this.multipleSelection;
          for(var i=0;i<tenantData.length;i++){
             var obj={};
             obj.associatedUserId=tenantData[i].tenantId;
             obj.userType=0;
             obj.userName=tenantData[i].tenantName;
             rtnData.push(obj);
        }
        return rtnData;
    },
    //获取离线密码
    getOffLinePassword(){
        if(this.deviceId==""||this.deviceId==null){
           this.$message({
            message: this.$t('roomDetail.roomNoBindDeviceaZ'),
            type: "warning"
           });
          return false;
        }
        var formData = new FormData();
        formData.append("deviceId", this.deviceId);
        formData.append("buildTime",this.$util.formartDateTime(new Date()));
        this.$server
        .exam("/customer/lock/getOfflineTempPass", formData)
        .then(data => {
          if (data.code == 200) {
            this.offLinePassword=data.data;
            this.pswDialogVisible=true;
          } 
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },
    //返回首页
    backHome(){
       this.$router.push({path: "/roomList",query: {}});
    },
    getTenantPage(){
      var formData = new FormData();
      formData.append("roomId", this.roomId);
      formData.append("userType",0);
      formData.append("pageNo", 1);
      formData.append("pageSize",10);
      this.$server
      .exam("/customer/room/listTenantAuthorized", formData)
      .then(data => {
        if (data.code == 200) {
          this.addAutoForm.tenantData=data.data.records;    
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    }, 
    getAlarmRecordPage(){
        var formData = new FormData();
        formData.append("deviceId", this.deviceId);
        formData.append("pageNo", this.alarmRecordPageData.offset);
        formData.append("pageSize", this.alarmRecordPageData.pageNumber);
        this.$server
        .exam("/customer/apartment/listDeviceAlarmRecord", formData)
        .then(data => {
          if (data.code == 200) {
            this.alarmRecordPageData.alarmRecordData=data.data.records;
            this.alarmRecordPageData.total = data.data.total;
          } 
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },
    getOpenRecordPage(){
        var formData = new FormData();
        formData.append("deviceId", this.deviceId);
        formData.append("pageNo", this.openRecordPageData.offset);
        formData.append("pageSize", this.openRecordPageData.pageNumber);
        this.$server
        .exam("/customer/apartment/listLockOpenRecord", formData)
        .then(data => {
          if (data.code == 200) {
            this.openRecordPageData.openRecordData=data.data.records;
            this.openRecordPageData.total = data.data.total;
          }
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },
    getAuthPage(){
        var formData = new FormData();
        formData.append("deviceId", this.deviceId);
        formData.append("pageNo", this.authPageData.offset);
        formData.append("pageSize", this.authPageData.pageNumber);
        this.$server
        .exam("/customer/apartment/listLockAuthorization", formData)
        .then(data => {
          if (data.code == 200) {
            this.authPageData.authData=data.data.records;
            this.authPageData.total = data.data.total;
          }
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },
    getUserPage(){
        var formData = new FormData();
        formData.append("roomId", this.roomId);
        formData.append("pageNo", this.userPageData.offset);
        formData.append("pageSize", this.userPageData.pageNumber);
        formData.append("userType",0);
        this.$server
        .exam("/customer/room/listTenantAuthorized", formData)
        .then(data => {
          if (data.code == 200) {
            this.userPageData.userData=data.data.records;
            this.userPageData.total = data.data.total;
          }
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },
    getDeviceDetail(){
        var formData = new FormData();
        formData.append("deviceId", this.deviceId);
        this.$server
        .exam("/customer/apartment/getLockDetail", formData)
        .then(data => {
          if (data.code == 200) {
            this.deviceData=data.data;
          }
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },
     userHandleSizeChange(val) {
       this.userPageData.pageNumber = val;
       this.getUserPage();
     },
     userHandleCurrentChange(val) {
       this.userPageData.offset = val;
       this.getUserPage();
     },
     authHandleSizeChange(val) {
       this.authPageData.pageNumber = val;
       this.getAuthPage();
     },
     authHandleCurrentChange(val) {
       this.authPageData.offset = val;
       this.getAuthPage();
     },
     openRecordHandleSizeChange(val) {
       this.openRecordPageData.pageNumber = val;
       this.getOpenRecordPage();
     },  
     openRecordHandleCurrentChange(val) {
       this.openRecordPageData.offset = val;
       this.getOpenRecordPage();
     },  
     alarmRecordHandleSizeChange(val) {
       this.alarmRecordPageData.pageNumber = val;
       this.getAlarmRecordPage();
     }, 
     alarmRecordHandleCurrentChange(val) {
        this.alarmRecordPageData.offset = val;
        this.getAlarmRecordPage();
     }  
  }           
}
</script>

<style>
 .el-dialog__header{
  border-bottom: 1px solid #e8eaec;
}
.el-dialog__footer {
  border-top: 1px solid #e8eaec;
}
</style>


// WEBPACK FOOTER //
// src/components/room/roomDetail.vue